// extracted by mini-css-extract-plugin
export default {"layer":"styles_layer__wbsui","disabled":"styles_disabled__uC9w5"};